import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';

export const CopyLayer = styled.section`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${r('gap', 10)}
  ${r('margin-top', 24)}
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: var(--type-subtitle-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
  text-align: left;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-regular);
  white-space: nowrap;
`;

export const SubtitleAccent = styled.span`
  font-family: var(--font-display);
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0;
  font-size: var(--type-title-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
  text-align: center;
`;

export const TitlePlain = styled.span`
  display: block;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-extrabold);
`;

export const TitleAccent = styled.span`
  display: block;
  font-family: var(--font-display);
  font-weight: var(--font-weight-regular);
`;
